import { Translations } from "./en";

export const sr: Translations = {
  // Navigation
  nav: {
    dashboard: "Kontrolna tabla",
    buildings: "Zgrade",
    units: "Jedinice",
    contracts: "Ugovori",
    buyers: "Kupci",
    reports: "Izveštaji",
    settings: "Podešavanja",
  },
  
  // User Menu
  user: {
    profile: "Profil",
    appearance: "Izgled",
    light: "Svetlo",
    dark: "Tamno",
    system: "Sistemski",
    language: "Jezik",
    currency: "Valuta",
    english: "English",
    serbian: "Srpski",
    bam: "BAM",
    eur: "EUR",
    usd: "USD",
    rsd: "RSD",
    logout: "Odjava",
  },

  // Common
  common: {
    search: "Pretraga",
    filter: "Filter",
    add: "Dodaj",
    edit: "Izmeni",
    delete: "Obriši",
    cancel: "Otkaži",
    save: "Sačuvaj",
    saveChanges: "Sačuvaj izmene",
    back: "Nazad",
    next: "Dalje",
    continue: "Nastavi",
    view: "Pregledaj",
    viewAll: "Pogledaj sve",
    viewDetails: "Pogledaj detalje",
    download: "Preuzmi",
    export: "Izvezi",
    import: "Uvezi",
    close: "Zatvori",
    actions: "Akcije",
    status: "Status",
    type: "Tip",
    date: "Datum",
    price: "Cena",
    total: "Ukupno",
    all: "Sve",
    none: "Ništa",
    yes: "Da",
    no: "Ne",
    loading: "Učitavanje...",
    noResults: "Nema rezultata",
    enable: "Omogući",
    change: "Promeni",
    rows: "redova",
    units: "jedinica",
    notFound: "Nije pronađeno",
    required: "Obavezno",
    optional: "Opciono",
    errorOccurred: "Došlo je do greške.",
    notes: "Napomene",
    address: "Adresa",
    name: "Ime",
    email: "Email",
    phone: "Telefon",
    id: "ID",
    location: "Lokacija",
    method: "Metod",
    reference: "Referenca",
    amount: "Iznos",
    remaining: "Preostalo",
    complete: "završeno",
    overdue: "Prekoračeno",
    pending: "Na čekanju",
    legend: "Legenda",
    customerSince: "Kupac od",
    contactInfo: "Kontakt informacije",
  },

  // Dashboard
  dashboard: {
    title: "Kontrolna tabla",
    description: "Dobrodošli nazad. Evo pregleda vašeg portfolija nekretnina.",
    totalBuildings: "Ukupno zgrada",
    acrossLocations: "Na {count} lokacija",
    activeUnits: "Aktivne jedinice",
    activeContracts: "Aktivni ugovori",
    pendingSignature: "{count} čeka potpis",
    revenueCollected: "Prikupljeni prihod",
    outstanding: "{amount} preostalo",
    fromLastMonth: "u odnosu na prošli mesec",
    revenueCollection: "Naplata prihoda",
    collected: "Naplaćeno",
    projected: "Projektovano",
    unitStatusOverview: "Pregled statusa jedinica",
    totalUnits: "Ukupno jedinica",
    recentPayments: "Nedavne uplate",
    pendingActions: "Akcije na čekanju",
    viewAllActions: "Pogledaj sve akcije",
    pendingBuyerSignature: "Čeka potpis kupca",
    overduePayment: "Prekoračena uplata",
    loadError: "Neuspešno učitavanje pregleda kontrolne table.",
    portfolioValue: "Vrijednost portfolija",
    overdueAmount: "Dospjelo",
    availableValue: "Slobodni stanovi",
    salesCompletion: "% Portfolio prodan",
    overdueAlert: "{count} dospjelih uplata · {amount} ukupno",
    unsignedAlert: "{count} ugovora bez potpisa",
    buildingOverview: "Pregled zgrada",
    upcomingPayments30: "Predstojeće uplate · 30 dana",
    noUpcoming: "Nema uplata u narednih 30 dana",
    noOverdue: "Sve uplate su na vrijeme",
    emptyTitle: "Dobrodošli u Kvadrat",
    emptyDescription: "Vaš portfolio je prazan. Počnite dodavanjem prve zgrade — kada je podesite, možete uvoziti jedinice, kreirati ugovore i pratiti uplate na jednom mestu.",
    emptySubtext: "Potrebno je samo nekoliko minuta za početak.",
    emptyAction: "Dodajte prvu zgradu",
  },

  // Buildings
  buildings: {
    title: "Zgrade",
    description: "Upravljajte projektima zgrada i pratite njihov napredak.",
    addBuilding: "Dodaj zgradu",
    addNewBuilding: "Dodaj novu zgradu",
    editBuilding: "Izmeni zgradu",
    viewUnits: "Pogledaj jedinice",
    manageFloors: "Upravljaj spratovima",
    lamellas: "Lamele",
    invested: "Uloženo",
    salesProgress: "Napredak prodaje",
    sold: "Prodato",
    contracted: "Ugovoreno",
    available: "dostupno",
    statusPlanning: "Planiranje",
    statusConstruction: "U izgradnji",
    statusSelling: "Prodaja",
    statusCompleted: "Završeno",
    backToBuildings: "Nazad na zgrade",
    backToBuilding: "Nazad na zgradu",
    floorGrid: "Raspored spratova",
    totalValue: "Ukupna vrednost",
    notFound: "Zgrada nije pronađena.",
    loadError: "Neuspešno učitavanje zgrada.",
    loadOneError: "Neuspešno učitavanje zgrade.",
    deleteConfirm: "Obriši zgradu \"{name}\"? Ova akcija se ne može poništiti. Sve lamele moraju biti uklonjene.",
    deleteLamellaConfirm: "Obriši lamelu {name}? Sve jedinice u ovoj lameli moraju biti uklonjene.",
  },

  // Units
  units: {
    title: "Jedinice",
    description: "{count} jedinica u {lamellas} lamela",
    addUnit: "Dodaj jedinicu",
    editUnit: "Izmeni jedinicu",
    createContract: "Napravi ugovor",
    searchPlaceholder: "Pretraži po ID jedinice ili naslovu...",
    totalUnits: "Ukupno jedinica",
    available: "Dostupno",
    contracted: "Ugovoreno",
    sold: "Prodato",
    totalValue: "Ukupna vrednost",
    soldValue: "Vrednost prodatog",
    allLamellas: "Sve lamele",
    lamella: "Lamela",
    allTypes: "Svi tipovi",
    apartments: "Stanovi",
    parking: "Parking",
    storage: "Ostave",
    commercial: "Poslovni prostor",
    allStatus: "Svi statusi",
    unit: "Jedinica",
    floor: "Sprat",
    area: "Površina",
    noUnitsMatch: "Nijedna jedinica ne odgovara filterima.",
    backToUnits: "Nazad na jedinice",
    unitDetails: "Detalji jedinice",
    pricePerSqm: "Cena po m²",
    noContractLinked: "Nema povezanog ugovora",
    notFound: "Jedinica nije pronađena.",
    loadError: "Neuspešno učitavanje jedinice.",
    deleteConfirm: "Obriši jedinicu {number}? Mogu se brisati samo slobodne jedinice.",
  },

  // Contracts
  contracts: {
    title: "Ugovori",
    description: "Upravljajte ugovorima kupaca i pratite napredak plaćanja.",
    newContract: "Novi ugovor",
    editContract: "Izmeni ugovor",
    addPayment: "Dodaj uplatu",
    downloadPdf: "Preuzmi PDF",
    searchPlaceholder: "Pretraži po broju ugovora, kupcu ili jedinici...",
    totalContracts: "Ukupno ugovora",
    signed: "Potpisano",
    collected: "Naplaćeno",
    outstanding: "Preostalo",
    allContracts: "Svi ugovori",
    pendingSignature: "Čeka potpis",
    fullyPaid: "Potpuno plaćeno",
    partiallyPaid: "Delimično plaćeno",
    unpaid: "Neplaćeno",
    contract: "Ugovor",
    buyers: "Kupci",
    paymentProgress: "Napredak plaćanja",
    pending: "Na čekanju",
    paid: "Plaćeno",
    partial: "Delimično",
    noContractsMatch: "Nijedan ugovor ne odgovara filterima.",
    unknown: "Nepoznato",
    backToContracts: "Nazad na ugovore",
    contractInfo: "Informacije o ugovoru",
    contractDate: "Datum ugovora",
    signedDate: "Datum potpisivanja",
    paymentType: "Tip plaćanja",
    paymentSchedule: "Plan plaćanja",
    paymentHistory: "Istorija plaćanja",
    recordPayment: "Evidentuj uplatu",
    dueDate: "Rok plaćanja",
    paidDate: "Datum uplate",
    paidOf: "plaćeno od",
    contractNumber: "Ugovor #",
    noContractsYet: "Još nema ugovora",
    notFound: "Ugovor nije pronađen.",
    loadError: "Neuspešno učitavanje ugovora.",
    loadOneError: "Neuspešno učitavanje ugovora.",
    deleteConfirm: "Obriši ugovor #{number}? Mogu se brisati samo ugovori bez uplata.",
    wizardDescription: "Vođeno kreiranje ugovora: kupac, jedinice, ukupno i potvrda.",
    wizardStepOf: "Korak {current} od {total}",
    wizardStepBuyer: "Kupac",
    wizardStepUnits: "Jedinice",
    wizardStepTotalsPayment: "Ukupno i plaćanje",
    wizardStepConfirmation: "Potvrda",
    wizardSelectPaymentMethod: "Izaberite najmanje jedan način plaćanja.",
    wizardRequiredBuyerFields: "Popunite sva obavezna polja kupca.",
    wizardReviewTitle: "Pregled izbora",
    wizardFileUploadTitle: "Otpremanje ugovora",
    wizardUploadHint: "Otpremite potpisan papirni ugovor (opciono)",
    wizardNoFile: "Nije izabran fajl.",
    generateSchedule: "Generiši plan plaćanja",
    numberOfInstallments: "Broj rata",
    generate: "Generiši",
    addInstallment: "Dodaj ratu",
    scheduleTotal: "Ukupno po planu",
    scheduleVsRemaining: "vs preostalo",
    saveSchedule: "Sačuvaj plan",
    scheduleCreated: "Plan kreiran",
    scheduleCreatedDesc: "Sačuvano {count} rata.",
    markAsPaid: "Označi kao plaćeno",
    markAsUnpaid: "Poništi plaćanje",
    generateScheduleButton: "Generiši plan",
  },

  // Buyers
  buyers: {
    title: "Kupci",
    description: "Upravljajte profilima kupaca i pratite njihove ugovore.",
    addBuyer: "Dodaj kupca",
    editBuyer: "Izmeni kupca",
    viewProfile: "Pogledaj profil",
    viewContracts: "Pogledaj ugovore",
    logCommunication: "Zabeleži komunikaciju",
    searchPlaceholder: "Pretraži po imenu, email-u ili telefonu...",
    totalBuyers: "Ukupno kupaca",
    totalContracts: "Ukupno ugovora",
    totalPaid: "Ukupno plaćeno",
    outstanding: "Preostalo",
    buyer: "Kupac",
    contact: "Kontakt",
    balance: "Stanje",
    paidInFull: "Plaćeno u celosti",
    noBuyersMatch: "Nijedan kupac ne odgovara pretrazi.",
    contract: "ugovor",
    contracts: "ugovora",
    paid: "Plaćeno",
    backToBuyers: "Nazad na kupce",
    buyerNotFound: "Kupac nije pronađen.",
    loadError: "Neuspešno učitavanje kupaca.",
    loadOneError: "Neuspešno učitavanje kupca.",
    deleteConfirm: "Obriši kupca \"{name}\"? Mogu se brisati samo kupci bez ugovora.",
  },

  // Not Found page
  notFound: {
    description: "Ups! Stranica nije pronađena",
    returnHome: "Nazad na početnu",
  },

  // Reports
  reports: {
    title: "Izveštaji",
    description: "Generišite i izvezite operativne i finansijske izveštaje.",
    operationalReports: "Operativni izveštaji",
    financialReports: "Finansijski izveštaji",
    unitStatusReport: "Izveštaj o statusu jedinica",
    unitStatusDesc: "Pregled dostupnih, ugovorenih i prodatih po zgradi",
    contractSummary: "Pregled ugovora",
    contractSummaryDesc: "Svi ugovori sa statusom i preostalim iznosima",
    buyerReport: "Izveštaj o kupcima",
    buyerReportDesc: "Svi kupci sa njihovim ugovorima i istorijom plaćanja",
    cashFlowAnalysis: "Analiza novčanog toka",
    cashFlowDesc: "Primljene uplate po periodima sa trendovima",
    outstandingBalances: "Preostala dugovanja",
    outstandingDesc: "Izveštaj o starosti neplaćenih iznosa",
    projectPL: "Projekat P&L",
    projectPLDesc: "Investicija nasuprot prodaji po zgradi",
    upcomingPayments: "Predstojeće uplate",
    upcomingPaymentsDesc: "Planirane uplate koje dospijevaju u narednih 30 / 60 / 90 dana",
    salesVelocity: "Prodajna dinamika",
    salesVelocityDesc: "Broj ugovorenih jedinica po mjesecu",
    contractsWithoutPlan: "Ugovori bez plana plaćanja",
    contractsWithoutPlanDesc: "Aktivni ugovori koji nemaju ni plan ni uplaćenih rata",
    daysUntilDue: "Dana do dospijeća",
    unitsContracted: "Ugovorenih jedinica",
    noPlan: "Bez plana",
  },

  // Settings
  settings: {
    title: "Podešavanja",
    description: "Upravljajte nalogom i podešavanjima aplikacije.",
    profile: "Profil",
    fullName: "Puno ime",
    email: "Email",
    companyName: "Naziv kompanije",
    taxId: "PIB",
    notifications: "Obaveštenja",
    emailNotifications: "Email obaveštenja",
    emailNotificationsDesc: "Primajte email obaveštenja o uplatama i ugovorima",
    paymentReminders: "Podsetnici za plaćanje",
    paymentRemindersDesc: "Budite obavešteni o predstojećim i prekoračenim uplatama",
    contractAlerts: "Upozorenja o ugovorima",
    contractAlertsDesc: "Obaveštenja za ugovore koji čekaju potpis",
    display: "Prikaz",
    darkMode: "Tamni režim",
    darkModeDesc: "Prebacujte između svetle i tamne teme",
    compactView: "Kompaktan prikaz",
    compactViewDesc: "Prikažite više podataka sa smanjenim razmakom",
    security: "Bezbednost",
    twoFactorAuth: "Dvofaktorska autentifikacija",
    twoFactorDesc: "Dodajte dodatni nivo bezbednosti svom nalogu",
    changePassword: "Promeni lozinku",
    changePasswordDesc: "Ažurirajte lozinku naloga",
    contactName: "Ime kontakta",
    contactPhone: "Telefon kontakta",
    companyAddress: "Adresa firme",
    currentPassword: "Trenutna lozinka",
    newPassword: "Nova lozinka",
    passwordSaved: "Lozinka uspješno promijenjena.",
    profileSaved: "Profil sačuvan.",
    saveError: "Greška pri čuvanju.",
  },

  // Import Dialog
  import: {
    title: "Uvoz jedinica",
    uploadDesc: "Otpremite Excel ili CSV fajl za uvoz jedinica",
    mappingDesc: "Mapirajte kolone fajla na polja jedinica",
    previewDesc: "Pregledajte podatke pre uvoza",
    resultDesc: "Uvoz je završen. Pregledajte sažetak i probleme.",
    upload: "Otpremi",
    mapping: "Mapiranje",
    preview: "Pregled",
    report: "Izveštaj",
    dropFile: "Prevucite fajl ovde ili kliknite za pretragu",
    supportedFormats: "Podržani formati: Excel (.xlsx, .xls) i CSV",
    selectFile: "Izaberi fajl",
    columnMapping: "Mapiranje kolona",
    rawFileSample: "Uzorak iz fajla",
    sampleRows: "Uzorak od {count} redova",
    filePreview: "Pregled fajla (prvih 10 redova)",
    mapRequired: "Mapirajte sva obavezna polja za nastavak.",
    selectColumn: "Izaberi kolonu",
    notMapped: "-- Nije mapirano --",
    backToMapping: "Nazad na mapiranje",
    continueToPreview: "Nastavi na pregled",
    runImport: "Pokreni uvoz",
    importing: "Uvoz u toku...",
    importFailed: "Uvoz nije uspeo",
    importFailedDesc: "Nije moguće uvesti fajl. Pokušajte ponovo.",
    importFinished: "Uvoz je završen. Pregledajte sažetak i probleme po redovima.",
    importedCount: "Uvezeno: {count}",
    skippedCount: "Preskočeno: {count}",
    errorCount: "Grešaka: {count}",
    totalCount: "Ukupno: {count}",
    totalRows: "Ukupno redova: {count}",
    validRows: "Ispravnih: {count}",
    warningRows: "Upozorenja: {count}",
    erroredRows: "Greške: {count}",
    reportBuildings: "Zgrade: nove {new}, postojeće {existing}",
    reportLamellas: "Lamele: nove {new}, postojeće {existing}",
    reportFloors: "Spratovi: novi {new}, postojeći {existing}",
    reportUnitTypes: "Tipovi jedinica: novi {new}, postojeći {existing}",
    reportUnits: "Jedinice: nove {new}, postojeće {existing}",
    issues: "Problemi",
    noIssuesFound: "Nema pronađenih problema.",
    ok: "U redu",
    row: "Red",
    severity: "Ozbiljnost",
    severityError: "Greška",
    severityWarning: "Upozorenje",
    code: "Kod",
    message: "Poruka",
    issueEmptyRow: "Red je prazan.",
    issueMissingBuildingName: "Naziv zgrade je obavezan.",
    issueMissingLamella: "Lamela je obavezna.",
    issueMissingUnitNumber: "Broj jedinice je obavezan.",
    issueMissingUnitType: "Tip jedinice je obavezan.",
    issueInvalidFloor: "Sprat mora biti ceo broj.",
    issueInvalidUnitValue: "Vrednost jedinice mora biti ispravan broj.",
    issueInvalidArea: "Površina mora biti ispravan broj.",
    issueDuplicateUnit: "Jedinica već postoji i preskočena je.",
    issueUnknown: "Neočekivana greška pri uvozu.",
    buildingName: "Naziv zgrade",
    buildingAddress: "Adresa zgrade",
    unitType: "Tip jedinice",
    unitValue: "Vrednost jedinice",
    importUnits: "Uvezi {count} jedinica",
    unitsToImport: "{count} jedinica za uvoz",
    importSuccessful: "Uvoz uspešan",
    importSuccessDesc: "{count} jedinica je uvezeno.",
    invalidFile: "Neispravan fajl",
    invalidFileDesc: "Fajl mora sadržati najmanje zaglavlje i jedan red podataka.",
    errorReading: "Greška pri čitanju fajla",
    errorReadingDesc: "Nije moguće parsirati fajl. Proverite da li je validan Excel ili CSV fajl.",
    unitNumber: "Broj jedinice",
    lamella: "Lamela",
    floor: "Sprat",
    areaSqm: "Površina (m²)",
    price: "Cena",
    type: "Tip",
    status: "Status",
    noBuyersFound: "Nema pronađenih kupaca",
    noUnitsFound: "Nema pronađenih jedinica",
    searchBuyers: "Pretraži kupce...",
    searchUnits: "Pretraži po broju jedinice ili lameli...",
    buyersSelected: "kupac(a) izabrano",
    unitsSelected: "jedinica izabrano",
  },

  // Forms
  forms: {
    // Building form
    buildingName: "Naziv zgrade",
    buildingNamePlaceholder: "npr., Kula Avala",
    addressPlaceholder: "Puna adresa uključujući grad i poštanski broj",
    lamellasPlaceholder: "npr., A, B, C",
    lamellasSeparatorHint: "Lista identifikatora lamela razdvojenih zarezom",
    selectStatus: "Izaberi status",
    totalInvestment: "Ukupna investicija (€)",
    totalInvestmentPlaceholder: "npr., 45000000",
    buildingUpdated: "Zgrada ažurirana",
    buildingCreated: "Zgrada kreirana",
    buildingUpdateSuccess: "{name} je uspešno ažurirano.",
    buildingCreateSuccess: "{name} je uspešno kreirano.",
    newBuilding: "Nova zgrada",
    updateBuildingInfo: "Ažuriraj informacije o zgradi",
    addNewBuildingProject: "Dodaj novi projekat zgrade",
    createBuilding: "Kreiraj zgradu",

    // Unit form
    unitNumberLabel: "Broj jedinice",
    unitNumberPlaceholder: "npr., A101",
    typePlaceholder: "Izaberi tip",
    floorPlaceholder: "Broj sprata",
    areaPlaceholder: "npr., 75.5",
    pricePlaceholder: "npr., 250000",
    unitUpdated: "Jedinica ažurirana",
    unitCreated: "Jedinica kreirana",
    unitUpdateSuccess: "Jedinica {number} je uspešno ažurirana.",
    unitCreateSuccess: "Jedinica {number} je uspešno kreirana.",
    newUnit: "Nova jedinica",
    updateUnitInfo: "Ažuriraj informacije o jedinici",
    addNewUnit: "Dodaj novu jedinicu u zgradu",
    createUnit: "Kreiraj jedinicu",

    // Buyer form
    fullNamePlaceholder: "npr., Petar Petrović",
    emailPlaceholder: "npr., milos.jovanovic@email.rs",
    phonePlaceholder: "npr., +381 11 123 4567",
    idNumberLabel: "JMBG / Broj lične karte",
    idNumberPlaceholder: "npr., 1234567890123",
    addressLabel: "Adresa",
    fullAddressPlaceholder: "Puna adresa",
    notesOptional: "Napomene (Opciono)",
    notesPlaceholder: "Dodatne napomene o kupcu...",
    buyerUpdated: "Kupac ažuriran",
    buyerCreated: "Kupac kreiran",
    buyerUpdateSuccess: "{name} je uspešno ažurirano.",
    buyerCreateSuccess: "{name} je uspešno dodato.",
    newBuyer: "Novi kupac",
    updateBuyerInfo: "Ažuriraj informacije o kupcu",
    addNewBuyer: "Dodaj novog kupca u sistem",

    // Contract form
    contractDate: "Datum",
    paymentTypeFull: "Puna uplata",
    paymentTypeInstallments: "Rate",
    paymentTypeCustom: "Prilagođeni plan",
    contractIsSigned: "Ugovor je potpisan",
    selectBuyer: "Izaberite najmanje jednog kupca",
    selectUnit: "Izaberite najmanje jednu jedinicu",
    contractUpdated: "Ugovor ažuriran",
    contractCreated: "Ugovor kreiran",
    contractUpdateSuccess: "Ugovor #{number} je uspešno ažuriran.",
    contractCreateSuccess: "Ugovor #{number} je uspešno kreiran.",
    updateContractDetails: "Ažuriraj detalje ugovora",
    createNewContract: "Kreiraj novi kupoprodajni ugovor",
    createContract: "Kreiraj ugovor",

    // Payment form
    recordPayment: "Evidentuj uplatu",
    paymentAmount: "Iznos uplate",
    paymentAmountPlaceholder: "npr., 50000",
    paymentDate: "Datum uplate",
    referenceLabel: "Referenca / ID transakcije",
    referencePlaceholder: "npr., TRX-001-2024",
    payFullRemaining: "Plati ceo preostali iznos",
    paymentRecorded: "Uplata evidentirana",
    paymentRecordedSuccess: "Uplata od {amount} je evidentirana.",
    amountError: "Iznos mora biti veći od 0",
    totalValueLabel: "Ukupna vrednost",
    paidSoFar: "Plaćeno do sada",
    error: "Greška",
    creditCard: "Kreditna kartica",
  },

  // Payment methods
  paymentMethods: {
    bankTransfer: "Bankarski prenos",
    check: "Ček",
    cash: "Gotovina",
    creditCard: "Kreditna kartica",
  },

  // Unit types
  unitTypes: {
    apartment: "Stan",
    parking: "Parking",
    storage: "Ostava",
    commercial: "Poslovni prostor",
    apt: "Stan",
    parkingSpot: "Parking mesto",
    storageUnit: "Ostava",
    commercialSpace: "Poslovni prostor",
  },

  // Unit statuses
  unitStatuses: {
    available: "Dostupno",
    contracted: "Ugovoreno",
    sold: "Prodato",
  },

  // Floor labels
  floors: {
    basement: "Podrum",
    ground: "Prizemlje",
    floor: "Sprat",
  },
};
